import Breadcrumb from "@/components/feature/Breadcrumb";
import { eventList } from "@/mocks/events";

export default function EventsHero() {
  return (
    <section className="w-full bg-background-100 border-b border-background-200">
      <div className="w-full px-5 md:px-10 pt-24 md:pt-32 pb-10 md:pb-14">
        <Breadcrumb items={[{ label: "事件追踪" }]} />
        <div className="mt-6 flex flex-col lg:flex-row lg:items-end justify-between gap-6">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-1.5 text-xs tracking-[0.22em] text-primary-600 font-medium">
              <span className="w-5 h-px bg-primary-400" />
              事件追踪总览
            </span>
            <h1 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              按时间线整理的热点事件库
            </h1>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
              共收录 {eventList.length} 起正在追踪或已有结论的事件。你可以按方向筛选，也可以直接搜索关键词，
              查看每一起事件从发生到最新进展的完整节点。
            </p>
          </div>
          <dl className="flex flex-wrap gap-6 md:gap-10">
            <div>
              <dt className="text-xs text-foreground-500">持续追踪中</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-primary-600">
                {eventList.filter((e) => e.status === "ongoing").length}
              </dd>
            </div>
            <div>
              <dt className="text-xs text-foreground-500">已有进展</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-accent-600">
                {eventList.filter((e) => e.status === "progress").length}
              </dd>
            </div>
            <div>
              <dt className="text-xs text-foreground-500">已有结论</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-secondary-700">
                {eventList.filter((e) => e.status === "concluded").length}
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}